// SupportWidget.jsx owns its own open/closed state internally and is
// rendered once, as a sibling of the routed app (App.js), so nothing under
// AppShell can reach it via props/context without a much bigger wiring
// change (same situation editorDirtyState.js solves for the opposite
// direction). A plain window CustomEvent is the lightest way for a distant
// trigger -- the account dropdown's "Help & Support" item -- to open it.
export const OPEN_SUPPORT_WIDGET_EVENT = "resumepilot360:open-support-widget";
